import lazyPage from "../../../../../../common/helpers/lazyPage";

export default lazyPage(
    "src/front/components/Task/types/SubScore/editor/subscoreeditor.tsx",
    () => import("./subscoreeditor"),
);
